import { useV2GetReleaseFlagQuery } from "@generated";
import { ReleaseFlag, ReleaseFlagStatus } from "../../types";

interface Result {
  releaseFlag: ReleaseFlag | null;
  isLoading: boolean;
  error: unknown;
}

const useGetReleaseFlag = (id: string): Result => {
  const { data, isLoading, error } = useV2GetReleaseFlagQuery({ id });

  if (!data?.data) return { releaseFlag: null, isLoading, error };

  const row = data.data;
  const releaseFlag: ReleaseFlag = {
    id: row.id ?? "",
    name: row.attributes.name,
    key: row.attributes.key,
    description: row.attributes.description ?? "",
    status: (row.attributes.status ?? "building") as ReleaseFlagStatus,
    betaReleaseDate: row.attributes["beta-release-date"] ?? "",
    generalAvailabilityDate: row.attributes["general-availability-date"] ?? "",
  };
  return { releaseFlag, isLoading, error };
};

export default useGetReleaseFlag;
